// extracted by mini-css-extract-plugin
export default {"education-container":"Education_education-container__7W9N2"};